import classNames from "classnames/bind";
import styles from "./FinanceExampleSidePanel.module.scss";
import Button from "common/blocks/Button";
import useModalContext from "common/providers/modal/useModalContext";

const cx = classNames.bind(styles);

export type FinanceExampleSidePanelFooterProps = {
    vehicleAdvertUri: string;
};

const FinanceExampleSidePanelFooter = (props: FinanceExampleSidePanelFooterProps) => {
    const { useSidebar } = useModalContext();
    const { closeSidebar } = useSidebar();

    return (
        <div className={cx("financeExampleFooter")}>
            <Button theme="secondary" fullWidth onClick={() => closeSidebar(true)} ariaLabel="Done">
                Done
            </Button>
            <Button
                theme="primary"
                fullWidth
                href={props.vehicleAdvertUri}
                ariaLabel="View vehicle"
            >
                View vehicle
            </Button>
        </div>
    );
};

export default FinanceExampleSidePanelFooter;
